import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CrudItemComponent, NavItem } from '@hutsix/ngxh6';
import { JobCardInterface } from '../../../../../_generated/api_interfaces/api/jobCard.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-job-time',
    templateUrl: './job-time.component.html',
    styleUrls: ['./job-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class JobTimeComponent {
    @Input() public job: Partial<{ hoursEstimate: number; hoursActual: number; referredToDipl: boolean }>;
}
